/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SessionCount } from "./SessionCount";
import {
    SessionCountFromJSON,
    SessionCountFromJSONTyped,
    SessionCountToJSON,
} from "./SessionCount";

/**
 *
 * @export
 * @interface SessionCountResponse
 */
export interface SessionCountResponse {
    /**
     *
     * @type {Array<SessionCount>}
     * @memberof SessionCountResponse
     */
    items?: Array<SessionCount>;
    /**
     * Currently always 'Australia/NEM_Time'. NEM Time is always UTC+10, with no daylight savings
     * @type {string}
     * @memberof SessionCountResponse
     */
    siteTimeZone?: string;
}

/**
 * Check if a given object implements the SessionCountResponse interface.
 */
export function instanceOfSessionCountResponse(
    value: object,
): value is SessionCountResponse {
    return true;
}

export function SessionCountResponseFromJSON(json: any): SessionCountResponse {
    return SessionCountResponseFromJSONTyped(json, false);
}

export function SessionCountResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): SessionCountResponse {
    if (json == null) {
        return json;
    }
    return {
        items:
            json["items"] == null
                ? undefined
                : (json["items"] as Array<any>).map(SessionCountFromJSON),
        siteTimeZone:
            json["siteTimeZone"] == null ? undefined : json["siteTimeZone"],
    };
}

export function SessionCountResponseToJSON(
    value?: SessionCountResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        items:
            value["items"] == null
                ? undefined
                : (value["items"] as Array<any>).map(SessionCountToJSON),
        siteTimeZone: value["siteTimeZone"],
    };
}
